import React from 'react';
import { Link } from 'react-router-dom';

export default function SupportPage() {
  return (
    <div className="home-page">
      <nav className="home-nav" aria-label="Home navigation">
        <div className="home-nav__inner">
          <Link to="/"><img src="/logo.png" alt="ProZpects" className="home-nav__logo" /></Link>
          <div className="home-nav__links">
            <Link to="/login" className="home-nav__link home-nav__link--login">Login</Link>
            <Link to="/register" className="home-nav__link home-nav__link--signup">Sign Up</Link>
          </div>
        </div>
      </nav>

      <main className="privacy-policy">
        <div className="privacy-policy__inner">
          <h1>App Support</h1>
          <p className="privacy-policy__effective">ProZpects — Athletic Recruiting Platform</p>

          <p>
            Need help with the ProZpects app? We're here for you. Browse the frequently asked
            questions below or reach out to us directly.
          </p>

          <h2>Contact Us</h2>
          <p>
            If you need help with the ProZpects app, have a question about your account, or want to
            report a problem, please reach out to our support team:
          </p>
          <ul>
            <li>Email: <a href="mailto:support@prozpects.com">support@prozpects.com</a></li>
            <li>Website: <a href="https://prozpects.com" target="_blank" rel="noopener noreferrer">prozpects.com</a></li>
          </ul>
          <p>We typically respond within 1–2 business days.</p>

          <h2>Frequently Asked Questions</h2>

          <h3>How do I reset my password?</h3>
          <p>
            On the login screen, tap <strong>Forgot Password</strong> and enter your email address.
            You'll receive a reset link within a few minutes. Check your spam folder if you don't
            see it in your inbox.
          </p>

          <h3>How do I delete my account?</h3>
          <p>
            You can delete your ProZpects account and associated data at any time from the{' '}
            <strong>Settings</strong> screen inside the app. Tap{' '}
            <strong>Settings → Delete Account</strong> and confirm. You may also email us at{' '}
            <a href="mailto:support@prozpects.com">support@prozpects.com</a> with the subject
            "Delete My Account" and we will process the deletion within 7 business days.
          </p>
          <p>When you delete your account:</p>
          <ul>
            <li>Your profile is removed from coach search results immediately</li>
            <li>Your personal data (name, contact info, profile, stats) is deleted from our active systems</li>
            <li>Uploaded media files (photos, videos) are removed from storage</li>
            <li>Message history with other users is removed</li>
            <li>
              Some data may be retained in encrypted backups for up to 90 days before permanent
              deletion, and limited records may be kept where required for legal, tax, or
              billing-dispute purposes
            </li>
          </ul>

          <h3>I signed up as a coach — why can't I search for athletes?</h3>
          <p>
            Coach accounts require manual review of school credentials and a background check before
            full access is granted. You'll receive an email at the address you registered with once
            your application has been approved. This process typically takes 1–2 business days.
          </p>

          <h3>I'm a coach and I haven't heard back about my application.</h3>
          <p>
            If it has been more than 2 business days since you registered, please email us at{' '}
            <a href="mailto:support@prozpects.com">support@prozpects.com</a> with the email address
            you used to sign up and we'll look into it right away.
          </p>

          <h3>My athlete profile isn't showing up in coach searches. Why?</h3>
          <p>
            A subscription isn't required to be included when coaches search — that's the same for
            Free and Pro. If a coach's search isn't turning you up, double-check that your profile
            is complete, since sport, position, grad year, and state are the fields coaches filter
            on most. Still not finding yourself? Email us at{' '}
            <a href="mailto:support@prozpects.com">support@prozpects.com</a>.
          </p>

          <h3>How do I add stats, photos, or highlight videos?</h3>
          <p>
            After logging in, navigate to your profile and use the tabs to add measurables, game
            stats, photos, and videos. Highlight videos can be added via a direct link (e.g.,
            Hudl or YouTube).
          </p>

          <h3>What does the blue verification dot mean?</h3>
          <p>
            A blue dot on a stat or measurable means it has been verified by a ProZpects partner
            or internal staff member. Verified data gives coaches greater confidence in the
            accuracy of an athlete's information.
          </p>

          <h3>Is ProZpects free for coaches?</h3>
          <p>
            Yes. Coaches have free access to search athlete profiles, view verified stats, and
            message athletes. No subscription is required.
          </p>

          <h3>How do I cancel my subscription?</h3>
          <p>
            Subscriptions purchased through the web are managed in <strong>Settings → Billing</strong>
            inside the app. Subscriptions purchased through the Apple App Store are managed through
            your Apple ID: go to <strong>Settings → [Your Name] → Subscriptions</strong> on your
            iPhone.
          </p>

          <h3>I was charged but my account still shows as free. What do I do?</h3>
          <p>
            Please email <a href="mailto:support@prozpects.com">support@prozpects.com</a> and
            include your account email and the date of the charge. We'll resolve it promptly.
          </p>

          <h3>How do I report a technical problem?</h3>
          <p>
            Email <a href="mailto:support@prozpects.com">support@prozpects.com</a> with a
            description of the issue, the device and iOS version you're using, and any screenshots
            that might help us reproduce the problem.
          </p>

          <h3>I'm not receiving emails from ProZpects.</h3>
          <p>
            Check your spam or junk folder. Add{' '}
            <a href="mailto:support@prozpects.com">support@prozpects.com</a> to your contacts
            to ensure future emails are delivered. If you still aren't receiving emails, contact
            us directly.
          </p>

          <h2>Privacy</h2>
          <p>
            For information about how we collect and use your data, please see our{' '}
            <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </div>
      </main>

      <footer className="home-footer">
        <div className="home-footer__inner">
          <p>&copy; 2026 ProZpects Recruiting Solutions LLC. All rights reserved.</p>
          <p>
            <Link to="/privacy" className="home-footer__link">Privacy Policy</Link>
            {' · '}
            <Link to="/support" className="home-footer__link">Support</Link>
          </p>
        </div>
      </footer>
    </div>
  );
}
